import { Component, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '@core/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import {
  UserAgreementDialogComponent
} from '@shared/components/dialogs/user-agreement-dialog/user-agreement-dialog.component';
import {
  PublicOfferDialogComponent
} from '@shared/components/dialogs/public-offer-dialog/public-offer-dialog.component';
import {SupportDialogComponent} from '@shared-v3/dialogs/support-dialog/support-dialog.component';
import {userType} from '@core/models';
import { DocDialogService } from '@core/services/doc-dialog.service';
import { FreeStudentSubscriptionsForTrialUserService } from '@core/services/promotions/free-student-subscriptions-for-trial-user.service';

@Component({
  selector: 'ms-dashboard-sidebar-teacher',
  templateUrl: './dashboard-sidebar-teacher.component.html',
  styleUrls: ['./dashboard-sidebar-teacher.component.scss'],
  standalone: false,
})
export class DashboardSidebarTeacherComponent {
  public readonly isFreeStudentSubscriptionsPromotionButtonShown: Signal<boolean>;

  public get freeStudentSubscriptionsPromotionPageURL(): string {
    return this._freeStudentSubscriptionsPromotionService.promotionPageURL;
  }

  get userType(): userType {
    return this._authService.accountType;
  }

  get isUkrainianLanguage(): boolean {
    const lang = (
      this._translateService.currentLang ||
      this._translateService.defaultLang ||
      ''
    ).toLowerCase();

    return lang.startsWith('ua') || lang.startsWith('uk');
  }

  constructor(
    protected readonly _matDialog: MatDialog,
    private readonly _authService: AuthService,
    private readonly _docDialogService: DocDialogService,
    private readonly _translateService: TranslateService,
    private readonly _freeStudentSubscriptionsPromotionService: FreeStudentSubscriptionsForTrialUserService,
  ) {
    this.isFreeStudentSubscriptionsPromotionButtonShown = toSignal(
      this._freeStudentSubscriptionsPromotionService.checkConditionsToShowNotification(),
      { initialValue: false },
    );
  }

  public handleTechSupportButtonClick(): void {
    this._matDialog.open(SupportDialogComponent, {
      width: '90vw',
      maxWidth: '500px',
      hasBackdrop: true,
      panelClass: 'support-dialog',
      backdropClass: 'blur-backdrop',
    });
  }

  public handleUserAgreementButtonClick(): void {
    this._docDialogService.open('personal-data');
  }

  public handlePublicOfferButtonClick(): void {
    this._docDialogService.open('offer');
  }
}
